import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Footer from "../../../components/Footer";
import TimeTableSidebar from "./TimetableSidebar";
import Header2 from "../../../components/Header2";
import { useDispatch, useSelector } from "react-redux";
import { getMasterDataByUserId } from "../../../pages/masterData/redux/masterDataThunk";
import userStore from "../../../zustand/userStore";
import GlobalJoyrideCloseButton from "../../../components/GlobalJoyrideCloseButton";

const TimetableLayout = () => {
  const userData = userStore((state) => state.user);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.masterData.loading);

  useEffect(() => {
    if (userData?.id) {
      dispatch(getMasterDataByUserId(userData.id));
    }
  }, [dispatch, userData?.id]);

  return (
    <div className="container-fluid vh-100 d-flex flex-column p-0">
      {/* <Header2 /> */}
      <div className="row flex-grow-1 m-0 overflow-hidden">
        <div className="col-12 p-0 d-flex flex-column h-100">
          <TimeTableSidebar />
          <div
            className="flex-grow-1 overflow-hidden d-flex"
            style={{
              position: "relative",
              background: "linear-gradient(to bottom, #ffffff 40%, #B9D9F0 100%)",
            }}
          >
            <div
              style={{
                content: "''",
                backgroundImage: `url('/images/schoold-home-banner.png')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "50%",
                opacity: 0.15,
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 0,
              }}
            />

            <div
              className="overflow-auto w-100 px-5"
              style={{
                zIndex: 1,
                position: "relative",

              }}

            >
              {/* <GlobalJoyrideCloseButton/> */}

              <Outlet />

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TimetableLayout;
